import React, { useState, useEffect } from "react";
import { Play, Menu, X } from "lucide-react";
import "./style.css";
import loadConfig from "../../../Services/Api/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { UpdateAcademicAchievement } from "../../../Redux/Reducers/Submitter/AcademicAchievement";
import { UpdateCurrentJobInformationSpecialization } from "../../../Redux/Reducers/Submitter/CurrentJobInformationSpecialization";
import { UpdateAI_NT_ApI_ApplicantInformation } from "../../../Redux/Reducers/Submitter/ApplicantInformation";
import Swal from "sweetalert2";
import { UpdateAC_NT_AS_AwardSource } from "../../../Redux/Reducers/Submitter/AwardSource";
import { UpdateAC_NT_CM_Commitment } from "../../../Redux/Reducers/Submitter/Commitment";
import { UpdateSC_NT_RI_ResearcherIndicators } from "../../../Redux/Reducers/Submitter/ResearcherIndicators";
import { UpdateSC_NT_AI_ApplicationInformation } from "../../../Redux/Reducers/Submitter/SC_NT_AI_ApplicationInformation";
import { UpdateQuestionsAnswersList } from "../../../Redux/Reducers/Submitter/QuestionsAnswers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faVideo } from "@fortawesome/free-solid-svg-icons";

const SubNavBar = () => {
  const [jsonData, setJsonData] = useState();
  const [menuOpen, setMenuOpen] = useState(false);
  const lang = useSelector((state) => state.languageReducer.Language);
  const navigate = useNavigate();
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  var guid = encryptedToken[encryptedToken.length - 1];
  console.log(guid, "dsssssssssfefefef");
  let location = useLocation();
  const { ApplicationInformationId } = useParams();
  console.log(ApplicationInformationId, "managerApplicationInformationId");

  const ApplicantInformation = useSelector(
    (state) => state.ApplicantInformation.ApplicantInformation
  );
  const academicAchievement = useSelector(
    (state) => state.AcademicAchievement.AcademicAchievement
  );
  const currentJobInformationSpecialization = useSelector(
    (state) =>
      state.CurrentJobInformationSpecialization
        .CurrentJobInformationSpecialization
  );
  const AwardSource = useSelector((state) => state.AwardSource.AwardSource);
  const Commitment = useSelector((state) => state.Commitment.Commitment);
  const SC_NT_AI_ApplicationInformation = useSelector(
    (state) =>
      state.SC_NT_AI_ApplicationInformation.SC_NT_AI_ApplicationInformation
  );
  const QuestionsAnswers = useSelector(
    (state) => state.QuestionsAnswers.QuestionsAnswers
  );
  const ResearcherIndicators = useSelector(
    (state) => state.ResearcherIndicators.ResearcherIndicators
  );

  const ActiveRound = useSelector(
    (state) => state.ApplicationInformation.ActiveRound
  );

  const disabled = ActiveRound;

  const dispatch = useDispatch();
  // Load JSON data
  const fetchData = async () => {
    const data = await loadConfig();
    setJsonData(data);
  };

  const Alert = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: lang == "ar" ? "تم الحفظ بنجاح" : "Saved Successfully",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Find active tab from current URL
  const activeTab = jsonData?.screens?.find((item) =>
    window.location.href.includes("manager")
      ? item.hrefManager + guid == location.pathname
      : item.href === location.pathname
  )?.code;

  const handleTabClick = (tabId, href) => {
    setMenuOpen(false);
    if (href) {
      navigate(href, { state: { from: location.pathname } });
    }
  };

  const handleVideoClick = (e, videoUrl) => {
    e.stopPropagation();
    e.preventDefault();
    if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };

  const UpdateAcademicAchievementFunction = () => {
    const formData = new FormData();
    formData.append(
      "AcademicAchievementId",
      academicAchievement?.academicAchievementId
    );
    formData.append(
      "SpecializationCertificateAttachment",
      academicAchievement?.specializationCertificateAttachment
    );
    if (
      academicAchievement?.yearOfGraduation_TimePeriodId != null &&
      academicAchievement?.yearOfGraduation_TimePeriodId != undefined
    ) {
      formData.append(
        "YearOfGraduation_TimePeriodId",
        academicAchievement?.yearOfGraduation_TimePeriodId
      );
    }

    formData.append(
      "ApplicationInformationId",
      localStorage.getItem("ApplicationInformationId")
    );
    formData.append("file", academicAchievement?.file);
    dispatch(UpdateAcademicAchievement(formData));
  };
  // const UpdateAcademicAchievementFunction = async () => {
  //   console.log(academicAchievement, "ssssjiidjiiiwjjjw");

  //   const formData = {
  //     AcademicAchievementId: academicAchievement?.academicAchievementId,
  //     SpecializationCertificateAttachment:
  //       academicAchievement?.specializationCertificateAttachment,
  //     YearOfGraduation_TimePeriodId:
  //       academicAchievement?.yearOfGraduation_TimePeriodId
  //         ? academicAchievement.yearOfGraduation_TimePeriodId
  //         : null,
  //     ApplicationInformationId:
  //       localStorage.getItem("ApplicationInformationId") ||
  //       ApplicationInformationId,
  //   };
  //   if (formData.AcademicAchievementId != null) {
  //     var result = await dispatch(UpdateAcademicAchievement(formData));
  //   }
  //   console.log(result, "ttttttt");

  //   return result?.payload?.code;
  // };
  const UpdateCurrentJobInformationSpecializationFunction = () => {
    dispatch(
      UpdateCurrentJobInformationSpecialization({
        currentJobInformationSpecializationId:
          currentJobInformationSpecialization?.currentJobInformationSpecializationId,
        countryId: currentJobInformationSpecialization?.countryId,
        city: currentJobInformationSpecialization?.city,
        university_Institution:
          currentJobInformationSpecialization?.university_Institution,
        college: currentJobInformationSpecialization?.college,
        department: currentJobInformationSpecialization?.department,
        jobTitle: currentJobInformationSpecialization?.jobTitle,
        academicRankId: currentJobInformationSpecialization?.academicRankId,
        generalSpecialization:
          currentJobInformationSpecialization?.generalSpecialization,
        subspecialization:
          currentJobInformationSpecialization?.subspecialization,
        applicationInformationId:
          currentJobInformationSpecialization?.applicationInformationId,
      })
    );
  };
  const UpdateApplicantInformation = () => {
    dispatch(
      UpdateAI_NT_ApI_ApplicantInformation({
        ...ApplicantInformation,
      })
    );
  };

  const AttachmentsAndDeclarationScreen = () => {
    dispatch(
      UpdateAC_NT_AS_AwardSource({
        ...AwardSource,
      })
    );

    dispatch(
      UpdateAC_NT_CM_Commitment({
        ...Commitment,
      })
    );
  };

  const formData = new FormData();

  QuestionsAnswers.forEach((item, index) => {
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsAnswersId`,
      item.questionsAnswersId
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].answer`,
      item.answer ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextAr`,
      item.questionTextAr ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextEn`,
      item.questionTextEn ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].sorting`,
      item.sorting ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsId`,
      item.questionsId ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].number`,
      item.number ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachments`,
      item.attachments ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].applicationInformationId`,
      item.applicationInformationId ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].numberShowStatus`,
      item.numberShowStatus ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachmentsShowStatus`,
      item.attachmentsShowStatus ?? ""
    );

    if (item.file) {
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].file`,
        item.file
      );
    }
  });

  const ScientificContributionSubmittedForTheAward = () => {
    dispatch(UpdateQuestionsAnswersList(formData));

    dispatch(
      UpdateSC_NT_RI_ResearcherIndicators({
        ...ResearcherIndicators,
      })
    );
    dispatch(
      UpdateSC_NT_AI_ApplicationInformation({
        ...SC_NT_AI_ApplicationInformation,
      })
    );
  };

  useEffect(() => {
    if (!disabled) {
      console.log(location?.state?.from,"from");
      
      if (location?.state?.from == "/ResearchersAward/WorkInformationAndAcademic") {
        UpdateAcademicAchievementFunction();
        UpdateCurrentJobInformationSpecializationFunction();
        location = null;
      }
      if (location?.state?.from == "/ResearchersAward/ApplicationInformation") {
        UpdateApplicantInformation();
      }
      if (
        location?.state?.from == "/ResearchersAward/AttachmentsAndDeclarationScreen"
      ) {
        AttachmentsAndDeclarationScreen();
        location = null;
      }
      if (
        location?.state?.from ==
        "/ResearchersAward/ScientificContributionSubmittedForTheAwardScreen"
      ) {
        ScientificContributionSubmittedForTheAward();
        location = null;
      }
    }
  }, [location.state?.from]);
  console.log(activeTab, "fffffffffgrgrgrg");

  return (
    <nav className="enhanced-navbar">
      <div className="enhanced-navbar-container">
        {/* Mobile burger button */}
        <button
          className="burger-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Overlay */}
        {menuOpen && (
          <div
            className="enhanced-navbar-overlay"
            onClick={() => setMenuOpen(false)}
          ></div>
        )}

        {/* Navigation items */}
        <ul className={`enhanced-navbar-list ${menuOpen ? "open" : ""}`}>
          {jsonData?.screens?.map((item, index) => (
            <li
              key={item.code}
              className={`enhanced-navbar-item ${
                index === jsonData.screens.length - 1 ? "last-item" : ""
              }`}
            >
              <a
                href={
                  window.location.href.includes("manager")
                    ? item.hrefManager + guid
                    : item.href
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleTabClick(
                    item.code,
                    window.location.href.includes("manager")
                      ? item.hrefManager + guid
                      : item.href
                  );
                }}
                className={`enhanced-navbar-link ${
                  activeTab === item.code ? "active" : ""
                }`}
              >
                <div className="enhanced-content-wrapper">
                  <span className="enhanced-text">
                    {lang === "ar" ? item.nameAR : item.nameEN}
                  </span>

                  {item.videoUrl && (
                    <button
                      onClick={(e) => handleVideoClick(e, item.videoUrl)}
                      className="enhanced-video-btn"
                      title={`${
                        lang === "ar"
                          ? `مشاهدة فيديو ${item.nameAR}`
                          : `Watch Video ${item.nameEN}`
                      }`}
                    >
                      {/* <Play size={14} /> */}
                      <FontAwesomeIcon icon={faVideo} size="lg" />
                    </button>
                  )}
                </div>
                <div className="enhanced-accent-border"></div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default SubNavBar;
